import { css } from 'styled-components'

export default function ({
  headingWrapperProps,
  imageWrapperProps,
}) {
  return {
    triangleProps: {
      clipReversed: true,
      clipDisabled: false,
    },
    wrapperProps: {
      mobileWrapperStyles: css`
        padding-top: 35px;
      `,
      tabletWrapperStyles: css`
        overflow: hidden;
        padding-top: 40px;
      `,
      desktopWrapperStyles: css`
        overflow: hidden;
      `,
    },
    containerProps: {
      mobileContainerStyles: {},
      tabletContainerStyles: {},
      desktopContainerStyles: css`
        flex-direction: row;
      `,
    },
    headingWrapperProps: {
      ...headingWrapperProps,
      desktopContainerStyles: css`
        width: 40%;
      `,
    },
    // Image Wrapper Styles and Props
    imageWrapperProps: {
      ...imageWrapperProps,
      mobileImageWrapperStyles: css` 
        margin-bottom: -35px;
        margin-top: 50px;
        position: relative;
      `,
      tabletImageWrapperStyles: css`
          margin-bottom: -95px;
          margin-top: 25px;
      `,
      desktopImageWrapperStyles: css`
        margin-bottom: 0;
        overflow: initial;
      `,
      // Browser Image
      browserImageProps: {
        mobileImageStyles: css`
          /* margin-bottom: -40px; */
          position: relative;
          right: -11%;
          width: 100vw;
          z-index: 100;
        `,
        tabletImageStyles: css`
          left: 13%;
          right: auto;
          width: 126vw;
          z-index: 0;
        `,
        desktopImageStyles: css`
          right: -8%;
          width: 110%;
          z-index: 100;
        `,
      },
      // Mobile image Image
      mobileImageProps: {
        mobileImageStyles: css`
          left: 5%;
          position: absolute;
          top: 20%;
          width: 35%;
          z-index: 101;
        `,
        tabletImageStyles: css`
          left: 10.4%;
          top: 18%;
          width: 35.5%;
          z-index: 0;
        `,
        desktopImageStyles: css`
          left: 10%;
          top: 17%;
          width: 40%;
          z-index: 101;
        `,
      },
    },
  }
}
